// Tabs/Components/SourceTree.tsx

import React, {useEffect, useState} from 'react';
import OdxTable from "../../../../OdxComponents/NativeOdx/Table/Odx-Table";
import {OdxTableRow} from "../../../../OdxComponents/NativeOdx/Table/Odx-TableRow";
import {OdxTableCell} from "../../../../OdxComponents/NativeOdx/Table/Odx-Tablecell";
import OdxChip from "../../../../OdxComponents/NativeOdx/Odx-Chip";
import {odxIconSets, odxVariants} from "../../../../OdxComponents/constants";
import {OdxSelectOptionProps} from "../../../../OdxComponents/NativeOdx/FormControls/Odx-Select";
import {useMain} from "../../../../Utils/SessionControls/mainContext";
import {SourceLayer} from "../../Interfaces/IKafkaEvents";
import {countEventsInChildren} from "../../Utils/eventEvaluation";

interface SourceTreeProps {
    layer: SourceLayer;
    onSelectLayer: (layer: SourceLayer) => void;
    logLevelFilter: string[];
}

const SourceTree: React.FC<SourceTreeProps> = ({
                                                   layer,
                                                   onSelectLayer,
                                                   logLevelFilter,
                                               }) => {

    const {createToast} = useMain();

    const handleRowClick = (index: number) => {
        const childLayer = layer.children[index];
        onSelectLayer(childLayer);
    };

    const isDisabled = (childLayer: SourceLayer) => {
        return logLevelFilter.every(logLvl => !countEventsInChildren(childLayer)[logLvl]);
    }

    const tableRows = layer.children.map((childLayer, index) => (
        <OdxTableRow key={index}
                     onClick={() => isDisabled(childLayer) ?
                         createToast({
                             message: "No events found for this layer",
                             variant: "default",
                             title: "No events found"
                         })
                         : handleRowClick(index)}
                     className={'cursor-pointer'}
        >
            <OdxTableCell>{childLayer.displayString}</OdxTableCell>
            <OdxTableCell>
                <div className="flex space-x-2 w-min">
                    {countEventsInChildren(childLayer)["Error"] > 0 && (
                        <OdxChip
                            size="small"
                            content={countEventsInChildren(childLayer)["Error"]}
                            variant={odxVariants.danger}
                        />
                    )}
                    {countEventsInChildren(childLayer)["Warning"] > 0 && (
                        <OdxChip
                            size="small"
                            content={countEventsInChildren(childLayer)["Warning"]}
                            variant={odxVariants.warning}
                        />
                    )}
                    {countEventsInChildren(childLayer)["Info"] > 0 && (
                        <OdxChip
                            size="small"
                            content={countEventsInChildren(childLayer)["Info"]}
                            variant={odxVariants.secondary}
                        />
                    )}
                </div>
            </OdxTableCell>
        </OdxTableRow>
    ));

    return (
        <div>
            <OdxTable id={"Logs_SourceTree_Table"}>{tableRows}</OdxTable>
        </div>
    );
};

export default SourceTree;
